import * as therapeuticAreaActionTypes from './therapeuticAreaActionTypes';

export const setAreaList = (areaList) => ({type: therapeuticAreaActionTypes.SET_AREA_LIST, areaList});

export const setArea = (area) => ({type: therapeuticAreaActionTypes.SET_AREA, area});

export const addArea = (area) => ({type: therapeuticAreaActionTypes.ADD_AREA, area});

export const updateArea = (area) => ({type: therapeuticAreaActionTypes.UPDATE_AREA, area});

export const deleteArea = (categoryId, areaId) => ({type: therapeuticAreaActionTypes.DELETE_AREA, areaId, categoryId});



// WEBPACK FOOTER //
// ./src/therapeuticArea/therapeuticAreaActions.js